// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2zCdx","selected":"Chip_selected__3hekr"};